import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import { UserService } from 'src/app/services/user-service/userservice';

@Component({
    selector: 'app-product-lizenz-dialog',
    templateUrl: './product-lizenz-dialog.component.html',
    styleUrls: ['./product-lizenz-dialog.component.scss'],
    standalone: false
})
export class ProductLizenzDialogComponent implements OnInit {
  public editable: boolean = true;
  public loading: any = false;
  public selectedProductId: any;
  public activeOrg: any;
  public productFromListing: any[] = [];
  public selectedGrantOptions: string = "";
  public activeListing: any;
  public ProductsToShow;
  public isPrioritized: boolean = false;
  private destroy$ = new Subject<void>();
  product: ProductInterface;
  name: string;
  constructor(
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<ProductLizenzDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private productService: ProductService,
    private router: Router,
    private userService: UserService,
    private organisationService: OrganisationService,
    public headerService: HeaderServiceService,
    private stripeService: StripeService
  ) {
    if (!this.userService.currentMemberships.find((orga) =>
      orga.organisationId ===
      this.organisationService.activeItem.organisationId
    )) {
      this.router.navigateByUrl('/marktplatz');
    }
  }

  async ngOnInit() {
    this.loading = true;
    this.activeOrg = this.headerService.activeOrganisation.organisationId;
    this.selectedProductId = this.data.productId;
    this.product = await this.productService.getItem(Number.parseInt(this.selectedProductId))
    this.name = this.product.name;
    await this.stripeService.loadProducts();
    this.loadProducts();
    this.loadProductsList();

  }

  onSave() {
    if (this.selectedGrantOptions.length === 0) {
      this.dialogService.openDialog(
        'Lizenzierung Fehlgeschlagen',
        'Bitte wählen Sie mindestens einen Authorization Abonnement aus der Liste aus.'
      );
      return;
    }
    else {
      this.dialogService
        .openConfirmDialog(
          'Möchten Sie dieses Produkt diesem Abonnement zuordnen?',
          'Abbrechen',
          'Bestätigen')
        .subscribe((confirmed) => {
          if (confirmed) {
            if (this.activeListing && this.activeListing.originListing.subscriptionId) {
              this.removeEntryAndAddEntry();
            }
            else {
              this.addOneEntry();
            }
          }
          else if (!confirmed) {
            this.loading = false;
            this.cdr.markForCheck();
            this.cdr.detectChanges();
          }
        });
    }
  }

  onCancel() {
    const productId = this.data.productId;
    const organisationId = this.organisationService.activeItem.organisationId;
    this.router.navigate([
      'organisations',
      organisationId,
      'products',
      productId
    ]);
    this.dialogRef.close(true);
  }

  onGrantSelection(selected: string) {
    this.selectedGrantOptions = selected;
  }


  loadProductsList(): void {
    this.loading = true;
    this.stripeService.getAllListingProductFromOrgId(this.activeOrg)
    .pipe(finalize(() => { this.loading = false; }))
    .subscribe({
      next: (data) => {
        if (data?.status >= 400) {
          console.error('Failed to load listing products.', data);
          return;
        }

        const productId = String(this.selectedProductId);
        const matchingIndex = data.findIndex(item =>
          Array.isArray(item.originListing?.products) && item.originListing.products.some(id => String(id) === productId)
        );
        if (matchingIndex !== -1) {
          this.activeListing = data[matchingIndex];
          this.isPrioritized = this.isProductPrioritized();
          const filteredData = data
            .filter((_, index) => index !== matchingIndex)
            .filter(item => item.originListing?.currentUsage < item.originListing?.listingCapacity);
          this.productFromListing = filteredData.sort((a, b) => b.originListing.id - a.originListing.id);
        } else {
          this.activeListing = null;
          this.productFromListing = data
            .filter(item => item.originListing?.currentUsage < item.originListing?.listingCapacity)
            .sort((a, b) => b.originListing.id - a.originListing.id);
        }
      },
      error: (err) => { console.error( 'Unexpected error while loading listing products.', err); }
    });
  }


  addOneEntry(): any {
    if (this.selectedProductId && this.selectedGrantOptions) {
      this.loading = true;
      this.stripeService.addProductsToListing(this.activeOrg, this.selectedGrantOptions, this.selectedProductId)
        .pipe(finalize(() => { this.loading = false;}))
        .subscribe({
          next: (data) => {
            if(data === null) return;
            if (data?.status == 226) {
              this.dialogService.openDialog('Die Zuordnung dieses Produkts zu diesem Abonnement ist fehlgeschlagen.', 'Dieses Abonnement ist voll');
              return;
            }
            if (data?.status >= 400) {
              this.dialogService.openDialog('Die Zuordnung dieses Produkts zu diesem Abonnement ist fehlgeschlagen.', 'Fehler beim  Zuordnung eines Produkts zu einem Abonnement,');
              return;
            } 
            const subPackage = this.productFromListing.find(
              (entry) => entry.originListing.subscriptionId === this.selectedGrantOptions);

            if (subPackage?.prioListing && subPackage.prioListing.currentUsage < subPackage.prioListing.listingCapacity) {
              this.askAndHandlePrioritization(this.selectedProductId);
            } else {
              this.selectedGrantOptions = '';
              this.dialogService.openDialog(
                'Produkt lizenziert',
                'Ihr Produkt ist nun mit einem neuen Abonnement lizenziert und veröffentlicht.'
              )
              .subscribe(() => {
                this.dialogRef.close(true);
              });
            }
          },
          error: (err) => {
            console.error( 'Unexpected error while adding product to subscription.', err);
          }
        });
    }
  }

  removeEntry(): any {
    this.dialogService
    .openConfirmDialog(
       'Möchten Sie die Zuordnung dieses Produkts zu diesem Abonnement wirklich aufheben?',
       'Abbrechen',
       'Bestätigen'
    )
    .subscribe((confirmed) => {
      if (!confirmed) {
        return;
      }
      this.loading = true;
      this.stripeService.removeProductFromListing(this.activeOrg, this.activeListing.originListing.subscriptionId, this.selectedProductId)
        .pipe(finalize(() => { this.loading = false;}))
        .subscribe({   
          next: (data) => {
            if (data?.status >= 400) {
              console.error('Failed to remove product from subscription.', data);
              this.dialogService.openDialog('Produkt konnte nicht entfernt werden', 'Fehler beim Entfernen des Produkts aus dem Abonnement.');
            } else {
              this.dialogService.openDialog('Produkt ist nicht mehr lizenziert', 'Ihr Produkt ist nun nicht mehr für Ihr Abonnement lizenziert und wird vom Marktplatz entfernt.');
              this.loadProductsList();
            }
          },
          error: (err) => {
            // Fallback for unexpected errors that are not handled by the service. Service already handles expected HTTP errors.
            console.error( 'Unexpected error while removing product from subscription.', err);
          }
        });
    });
  }

  removeEntryAndAddEntry(): void {
    this.loading = true;
    this.stripeService.removeProductFromListing(this.activeOrg, this.activeListing.originListing.subscriptionId, this.selectedProductId)
    .pipe(finalize(() => { this.loading = false;}))
    .subscribe({
      next: (data) => {
        if (data?.status >= 400) {
          this.dialogService.openDialog('Die Zuordnung dieses Produkts zu diesem Abonnement ist fehlgeschlagen.', 'Fehler beim  Zuordnung eines Produkts zu einem Abonnement,');
          return;
        }
          this.addOneEntry();
      },
      error: (err) => {
        console.error( 'Unexpected error while removing product from subscription.', err);
      }
    });
  }

  removePriorization(subscribtionId: string): void {
    this.dialogService
    .openConfirmDialog(
       'Möchten Sie die Priorisierung für dieses Produkt aufheben?',
       'Abbrechen',
       'Bestätigen'
    )
    .subscribe((confirmed) => {
      if (!confirmed) {
        return;
      }
      this.loading = true;
      this.stripeService.prioritizeProduct(this.activeOrg, subscribtionId, this.selectedProductId.toString(), false)
      .pipe(finalize(() => { this.loading = false;}))
      .subscribe({
        next: (prioritizeResponse) => {
          if (prioritizeResponse === null) return;
          if (prioritizeResponse?.status !== 200) {
            this.dialogService.openDialog(
              'Depriorisierung fehlgeschlagen',
              'Die Depriorisierung ist fehlgeschlagen. Bitte versuchen Sie es später erneut.'
            );
            return;
          } 
          this.dialogService.openDialog('Priorisierung aufgehoben', 'Das Produkt wird nicht mehr priorisiert angezeigt.');
          this.loadProductsList();
        },
        error: (err) => {
          console.error('Unexpected error while deprioritizing product.', err);
        }
      });
    });
  }

  addPriorization(subscribtionId: string): void {
    this.loading = true;
    this.stripeService.prioritizeProduct(this.activeOrg, subscribtionId, this.selectedProductId.toString(), true)
      .pipe(finalize(() => { this.loading = false;}))
      .subscribe({
        next: (prioritizeResponse) => {
          if (prioritizeResponse === null) return;
          if (prioritizeResponse?.status !== 200) {
            this.dialogService.openDialog(
              'Priorisierung fehlgeschlagen',
              'Die Priorisierung ist fehlgeschlagen. Bitte versuchen Sie es später erneut.'
            );
            return;
          } 
          this.dialogService.openDialog('Produkt priorisiert', 'Das Produkt wird jetzt priorisiert angezeigt.');
          this.loadProductsList();
        },
        error: (err) => {
          console.error('Unexpected error while prioritizing product.', err);
        }
      });
  }

  public showTarifeSelectionDialog() {
    this.dialogService.openTarifeSelectionDialog('', '', this.ProductsToShow)
      .subscribe((result) => {
        if (result) {
          this.loadProductsList();
        }
      });
  }

  private loadProducts(): void {
    this.stripeService.ProductsToShowObservable
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(products => {
        this.ProductsToShow = products;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private askAndHandlePrioritization(productId: number): void {
    this.dialogService.openConfirmDialog(
      'Produkt lizenziert',
      'Nein',
      'Ja',
      'Möchten Sie das Produkt entsprechend Ihrem Tarif priorisieren?'
    ).subscribe((result) => {
      if (result) {
        this.loading = true;
        this.stripeService.prioritizeProduct(this.activeOrg, this.selectedGrantOptions, productId.toString(), true)
        .pipe(
          finalize(() => { 
            this.loading = false;
            this.selectedGrantOptions = '';
          }),
        )
        .subscribe({
          next: (prioritizeResponse) => {
            if (prioritizeResponse === null) return;
            if (prioritizeResponse?.status !== 200) {
              this.dialogService.openDialog(
                'Priorisierung fehlgeschlagen',
                'Die Priorisierung ist fehlgeschlagen. Bitte versuchen Sie es später erneut.'
              );
            } else {
              this.dialogService.openDialog('Produkt priorisiert', 'Das Produkt wird jetzt priorisiert angezeigt.')
              .subscribe(() => {
                this.dialogRef.close(true);
              });
            }
          }, 
          error: (err) => {
            console.error('Unexpected error while prioritizing product.', err);
          }
        });
      } else {
        this.dialogRef.close(true);
      }
    });
  }

  isProductPrioritized(): boolean {
    const productId = String(this.selectedProductId);
    const prioProducts = this.activeListing?.prioListing?.products ?? [];
    return prioProducts.includes(productId);
  }
}

